import React from "react";
import ReactDOM from "react-dom";
import {Provider} from 'react-redux'
import 'babel-polyfill';
import store from './store/index'
import locale from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd'
import App from "./App";
// 引入antd样式
import 'antd/dist/antd.css'
// 全局样式
import './common/app.less'

import {domain} from './utils/u_Origin'
domain();

setTimeout(()=>{
    let rootRender = <Provider store={store}>
        <ConfigProvider locale={locale}>
            <App/>
        </ConfigProvider>
    </Provider>

    // 跨域响应事件
    window.addEventListener('message',function(event) {
        if(event.origin !== 'http://127.0.0.1:5500') return;
        // 把token存入缓存中cookie
    },false);

    ReactDOM.render(//ReactDOM.render用于将模板转为 HTML 语言，并插入指定的 DOM 节点。
        rootRender,
        document.getElementById("root")
    );
},200);
